import { hydrateRoot } from "react-dom/client";
import { App, type AppInitialData } from "./views/App";
import { parseLifeContentSnapshot } from "./models/life";

function readInitialData(): AppInitialData | undefined {
  const value = document.getElementById("initial-page-data")?.textContent;
  if (!value) return undefined;
  try {
    const parsed = JSON.parse(value) as { lifeContent?: unknown };
    const lifeContent = parseLifeContentSnapshot(parsed.lifeContent);
    return lifeContent ? { lifeContent } : undefined;
  } catch {
    return undefined;
  }
}

hydrateRoot(
  document.getElementById("root")!,
  <App
    url={`${window.location.pathname}${window.location.search}`}
    initialData={readInitialData()}
  />,
);
